var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanderConceptIconFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9333 10.5333C16.9333 10.5333 24.1333 15.9999 24.1333 23.8666C24.1333 25.9999 22.4 27.7333 20.1333 27.7333H9.06665C6.93332 27.7333 5.06665 25.9999 5.06665 23.8666C5.06665 15.9999 12.2666 10.5333 12.2666 10.5333C12.2666 10.5333 7.46665 6.39993 7.46665 5.0666C7.46665 3.59993 10.6666 5.8666 12.2666 5.8666C14.5333 5.8666 14.8 4.2666 16.2666 4.2666C17.7333 4.2666 17.8666 5.8666 20.2666 5.8666C21.0666 5.8666 19.3333 8.13327 16.9333 10.5333Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2666 10.5333H17.3333C19.1999 10.6667 21.0666 10.1333 22.5333 8.93335M17.3333 10.6667C18.2666 10.5333 19.1999 11.0667 19.7333 11.8667",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9333 16.8001C16.8 15.7334 15.7333 14.8001 14.5333 14.8001C13.2 14.8001 12.1333 15.6001 12.1333 16.9334C12.1333 18.2668 13.3333 18.8001 14.5333 19.0668C15.7333 19.3334 17.0666 20.0001 17.0666 21.3334C17.0666 22.6668 16 23.4668 14.6666 23.4668M12.2666 21.0668C12.2666 22.4001 13.3333 23.4668 14.6666 23.4668M14.6666 23.4668V24.6668M14.6666 14.8001V13.6001",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanderConceptIconFinance);
export default __webpack_public_path__ + "static/media/lander-concept-icon-finance.e3384a85a989c659f393a49a5187c7de.svg";
export { ForwardRef as ReactComponent };